import {
  COMMONCONFIGURADETAILS_SUCCESS,
  COMMONCONFIGURADETAILS_FAILED,
  RESET_COMMONCONFIGURADETAILS,
  LOADING_COMMONCONFIGURADETAILS,
  NETWORK_ERROR_COMMONCONFIGURADETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_COMMONCONFIGURADETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case COMMONCONFIGURADETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case COMMONCONFIGURADETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_COMMONCONFIGURADETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_COMMONCONFIGURADETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
